<template>
    <div class="container">
        <form method="post" :action="change_route">
            <input type="hidden" name="_token" v-bind:value="csrf">
            <div class="form-row">
                <div class="form-group col-12" v-if="!forgot_password">
                    <label for="old_password">{{ $lang('Stare hasło') }}</label>
                    <div style="position: relative">
                        <eye-password
                            field_id='old_password'
                            eye_id="old_eye"
                        ></eye-password>
                        <input class="form-control" id="old_password" name="old_password"
                               type="password" v-model="oldPassword"/>
                        <i id="old_eye"
                           style="position: absolute; right: 10px; top: 10px"
                           class="fa fa-eye" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="form-group col-12">
                    <label for="new_password">{{ $lang('Nowe hasło') }}</label>
                    <div style="position: relative">
                        <eye-password
                            field_id='new_password'
                            eye_id="new_eye"
                        ></eye-password>
                        <input class="form-control" id="new_password" name="new_password"
                               type="password" v-model="newPassword"/>
                        <i id="new_eye"
                           style="position: absolute; right: 10px; top: 10px"
                           class="fa fa-eye" aria-hidden="true"></i>
                    </div>
                    <div><small class="text-red" v-if="!validNewPasswordLength">
                        {{$lang('Hasło musi zawierać przynajmniej 12 znaków') }}
                    </small></div>
                    <div><small class="text-red" v-if="!validNewPasswordUppercase">
                        {{$lang('Hasło musi zawierać przynajmniej jedną wielką literę') }}
                    </small></div>
                    <div><small class="text-red" v-if="!validNewPasswordLowercase">
                        {{$lang('Hasło musi zawierać przynajmniej jedną małą literę') }}
                    </small></div>
                    <div><small class="text-red" v-if="!validNewPasswordDigit">
                        {{$lang('Hasło musi zawierać przynajmniej jedną cyfrę') }}
                    </small></div>
                    <div><small class="text-red" v-if="!validateSymbol">
                        {{$lang('Hasło musi zawierać przynajmniej jeden znak specjalny') }}
                    </small></div>
                </div>
                <div class="form-group col-12">
                    <label for="new_password_repeat">{{ $lang('Powtórz nowe hasło') }}</label>
                    <div style="position: relative">
                        <eye-password
                            field_id='new_password_repeat'
                            eye_id="repeat_eye"
                        ></eye-password>
                        <input class="form-control" id="new_password_repeat" name="new_password_repeat"
                               type="password" v-model="newPasswordRepeat"/>
                        <i id="repeat_eye"
                           style="position: absolute; right: 10px; top: 10px"
                           class="fa fa-eye" aria-hidden="true"></i>
                    </div>
                    <small class="text-red" v-if="!validRepeatedPassword">{{ $lang('Hasła nie są identyczne') }}</small>
                </div>
                <div class="col-12">
                    <button class="btn btn-primary float-right" :disabled="!validForm" type="submit">
                        {{ $lang('Zmień hasło') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import ShowNotification from "../../mixins/show-notification";

export default {
    name: 'library-change-password',
    mixins: [ShowNotification],
    props: {
        csrf: {type: String, required: true},
        change_route: {type: String, required: true},
        forgot_password: {type: Boolean, required: false, default: false}
    },
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            newPasswordRepeat: '',
        }
    },
    computed: {
        validNewPasswordLength() {
            return this.newPassword.length >= 12;
        },
        validNewPasswordUppercase() {
            return this.newPassword.toLowerCase() !== this.newPassword;
        },
        validNewPasswordLowercase() {
            return this.newPassword.toUpperCase() !== this.newPassword;
        },
        validNewPasswordDigit() {
            return /[0-9]/.test(this.newPassword);
        },
        validateSymbol() {
            return /\W/.test(this.newPassword);
        },
        validNewPassword() {
            return (this.validNewPasswordLength
                && this.validNewPasswordUppercase
                && this.validNewPasswordLowercase
                && this.validNewPasswordDigit
                && this.validateSymbol);
        },

        validRepeatedPassword() {
            return this.newPassword === this.newPasswordRepeat;
        },

        validForm() {
            return this.validNewPassword && this.validRepeatedPassword;
        }
    }
}
</script>
